const ISO_LIKE = /^(\d{4}-\d{2}-\d{2})(?:[T ](\d{2}:\d{2})(:\d{2})?(\.\d+)?)?(Z|[+-]\d{2}:\d{2})?$/

export default function formatUTCDate(date: string | unknown, dateStringLength: number = 19): string {
  if (date instanceof Date) {
    return date.toISOString().slice(0, dateStringLength)
  }

  if (typeof date !== 'string') {
    return ''
  }

  const parts = ISO_LIKE.exec(date)
  if (!parts) {
    return ''
  }

  const [, day, time = '00:00', seconds = ':00', fraction = '', zone = 'Z'] = parts
  const finalDate = new Date(`${day}T${time}${seconds}${fraction.slice(0, 4)}${zone}`)
  if (Number.isNaN(finalDate.getTime())) {
    return ''
  }

  return finalDate.toISOString().slice(0, dateStringLength)
}
